export const validationRules = {
  required: (value) => {
    if (Array.isArray(value))
      return value.length > 0 || "Este campo es requerido";
    if (typeof value === "boolean") return true;
    return !!value || "Este campo es requerido";
  },
  number: (value) => {
    if (!value) return true;
    return !isNaN(value) || "Debe ser un número válido";
  },
  integer: (value) => {
    if (!value) return true;
    return Number.isInteger(Number(value)) || "Debe ser un número entero";
  },

  positive: (value) => {
    if (!value) return true;
    return Number(value) > 0 || "Debe ser un número positivo";
  },
  min: (minValue) => (value) => {
    if (!value) return true;
    return Number(value) >= minValue || `El valor mínimo es ${minValue}`;
  },
  max: (maxValue) => (value) => {
    if (!value) return true;
    return Number(value) <= maxValue || `El valor máximo es ${maxValue}`;
  },
  url: (value) => {
    if (!value) return true;
    try {
      new URL(value);
      return true;
    } catch {
      return "Debe ser una URL válida";
    }
  },
  minLength: (minLength) => (value) => {
    if (!value) return true;
    return value.length >= minLength || `Mínimo ${minLength} caracteres`;
  },
  maxLength: (maxLength) => (value) => {
    if (!value) return true;
    return value.length <= maxLength || `Máximo ${maxLength} caracteres`;
  },
  selectOption: (value) => {
    return !!value || "Debe seleccionar una opción";
  },
  checkboxRequired: (value) => {
    if (Array.isArray(value)) {
      return value.length > 0 || "Debe seleccionar al menos una opción";
    }
    return !!value || "Este campo es requerido";
  },
  fileRequired: (value) => {
    return (value && value.length > 0) || "Debe seleccionar un archivo";
  },
  fileSize: (maxSizeMB) => (files) => {
    if (!files || files.length === 0) return true;
    const maxBytes = maxSizeMB * 1024 * 1024;
    for (let file of files) {
      if (file.size > maxBytes) {
        return `El archivo no debe superar ${maxSizeMB}MB`;
      }
    }
    return true;
  },
  email: (value) => {
    if (!value) return true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || "Debe ser un email válido";
  },
};

export function buildValidationRules(field) {
  const rules = [];

  if (field.required) {
    rules.push("required");
  }

  if (field.as === "link" || field.type === "url") {
    rules.push("url_validation");
  }

  if (field.type === "number" || field.as === "number") {
    rules.push("number");
  }

  if (field.type === "email") {
    rules.push("email");
  }

  if (field.pattern) {
    rules.push(`pattern:${field.pattern}`);
  }

  return rules.join("|") || "";
}

export function createValidationFunction(ruleString) {
  if (!ruleString || ruleString === "") {
    return () => true;
  }

  return (value) => {
    const rules = ruleString.split("|");

    for (const rule of rules) {
      if (rule === "required") {
        const result = validationRules.required(value);
        if (result !== true) return result;
      } else if (rule === "url_validation") {
        const result = validationRules.url(value);
        if (result !== true) return result;
      } else if (rule === "number") {
        const result = validationRules.number(value);
        if (result !== true) return result;
      } else if (rule === "email") {
        const result = validationRules.email(value);
        if (result !== true) return result;
      } else if (rule.startsWith("pattern:")) {
        const pattern = rule.substring(8);
        if (!value) continue;
        const regex = new RegExp(pattern);
        if (!regex.test(value)) {
          return "El formato no es válido";
        }
      }
    }

    return true;
  };
}
